var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5021 14.0831C13.4997 14.6397 12.9383 15.0897 12.249 15.0875C11.5596 15.0854 11.002 14.6318 11.0043 14.0752L11.0382 6.00836C11.0406 5.45175 11.602 5.00177 12.2913 5.00394C12.9807 5.00612 13.5383 5.45963 13.536 6.01624L13.5021 14.0831Z",
    fill: "#FF374D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2268 19.25C12.9249 19.25 13.5537 18.7526 13.5537 18.0667C13.5537 17.3808 12.9249 16.8834 12.2268 16.8834C11.5288 16.8834 10.8999 17.3808 10.8999 18.0667C10.8999 18.7526 11.5288 19.25 12.2268 19.25Z",
    fill: "#FF374D",
    stroke: "#FF374D",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/ExclamationMark.280f7f80.svg";
export { ForwardRef as ReactComponent };